var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSadFace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 45C69.5833 45 71.3542 44.2708 72.8125 42.8125C74.2708 41.3542 75 39.5833 75 37.5C75 35.4167 74.2708 33.6458 72.8125 32.1875C71.3542 30.7292 69.5833 30 67.5 30C65.4167 30 63.6458 30.7292 62.1875 32.1875C60.7292 33.6458 60 35.4167 60 37.5C60 39.5833 60.7292 41.3542 62.1875 42.8125C63.6458 44.2708 65.4167 45 67.5 45ZM32.5 45C34.5833 45 36.3542 44.2708 37.8125 42.8125C39.2708 41.3542 40 39.5833 40 37.5C40 35.4167 39.2708 33.6458 37.8125 32.1875C36.3542 30.7292 34.5833 30 32.5 30C30.4167 30 28.6458 30.7292 27.1875 32.1875C25.7292 33.6458 25 35.4167 25 37.5C25 39.5833 25.7292 41.3542 27.1875 42.8125C28.6458 44.2708 30.4167 45 32.5 45ZM50 57.5C44.3333 57.5 39.1875 59.1042 34.5625 62.3125C29.9375 65.5208 26.5833 69.75 24.5 75H32.75C34.5833 71.9167 37.0208 69.4792 40.0625 67.6875C43.1042 65.8958 46.4167 65 50 65C53.5833 65 56.8958 65.8958 59.9375 67.6875C62.9792 69.4792 65.4167 71.9167 67.25 75H75.5C73.4167 69.75 70.0625 65.5208 65.4375 62.3125C60.8125 59.1042 55.6667 57.5 50 57.5ZM50 100C43.0833 100 36.5833 98.6875 30.5 96.0625C24.4167 93.4375 19.125 89.875 14.625 85.375C10.125 80.875 6.5625 75.5833 3.9375 69.5C1.3125 63.4167 0 56.9167 0 50C0 43.0833 1.3125 36.5833 3.9375 30.5C6.5625 24.4167 10.125 19.125 14.625 14.625C19.125 10.125 24.4167 6.5625 30.5 3.9375C36.5833 1.3125 43.0833 0 50 0C56.9167 0 63.4167 1.3125 69.5 3.9375C75.5833 6.5625 80.875 10.125 85.375 14.625C89.875 19.125 93.4375 24.4167 96.0625 30.5C98.6875 36.5833 100 43.0833 100 50C100 56.9167 98.6875 63.4167 96.0625 69.5C93.4375 75.5833 89.875 80.875 85.375 85.375C80.875 89.875 75.5833 93.4375 69.5 96.0625C63.4167 98.6875 56.9167 100 50 100Z",
    fill: "url(#paint0_linear_11377_4773)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11377_4773",
    x1: 5.13231,
    y1: 94.8677,
    x2: 100.268,
    y2: -0.268016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSadFace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sad_face.5733f0dc9a42e9b4d45c6cb87e27b86a.svg";